<script setup>
import BreezeNavLink from '@/Components/NavLink.vue';
// import LangSelector from "@/Components/LangSelector.vue";
import ThemeSelector from '@/Components/ThemeSelector.vue';
import { usePage } from '@inertiajs/inertia-vue3';
import { computed } from 'vue';
import { __ } from '@/app';
import Logo from './Logo.vue';

const user = computed(() => usePage().props.value.auth.user);
</script>
<template>
    <!-- Navigation -->
    <nav class="navbar navbar-expand-lg navbar-custom">
        <div class="container">
            <a class="navbar-brand" :href="route('home')">
                <Logo width="120"/>
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                <span class="navbar-toggler-icon"></span>                
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav ms-auto">                    
                    <li class="nav-item" v-if="!user">
                        <BreezeNavLink :href="route('login')" :active="route().current('login')">{{ __('Zaloguj się') }}</BreezeNavLink>
                    </li>
                    <li class="nav-item" v-if="user">
                        <BreezeNavLink
                            :href="route('quiz')"
                            :active="route().current('quiz')"
                            >{{ __('Ćwiczenia') }}</BreezeNavLink
                        >
                    </li>
                    <li class="nav-item" v-if="user">
                        <BreezeNavLink
                            :href="route('statistics')"
                            :active="route().current('statistics')"
                            >{{ __('Statystyka') }}</BreezeNavLink
                        >
                    </li>
                    <li class="nav-item">
                        <BreezeNavLink
                            :href="route('contact')"
                            :active="route().current('contact')"
                            >{{ __('Kontakt') }}</BreezeNavLink>                        
                    </li>
                    <li class="nav-item" v-if="user">
                        <a class="nav-link" :href="route('logout')">{{ __('Wyloguj się') }}</a>
                    </li>
                    
                    <!-- <LangSelector /> -->
                    <ThemeSelector/>
                </ul>
            </div>
        </div>
    </nav>
</template>